import { render, staticRenderFns } from "./ModalAddChildOt.vue?vue&type=template&id=f0d97674&"
import script from "./ModalAddChildOt.vue?vue&type=script&lang=js&"
export * from "./ModalAddChildOt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports